import { isCustomRolesEnabled, isTeamsEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';

import type { Member } from './types';

export function hasCustomRoles(member: Member) {
  return isTeamsEnabled() && isCustomRolesEnabled() && member.customRoles.length > 0;
}
